/*
|--------------------------------------------------------------------------
| Data: SortBy
|--------------------------------------------------------------------------
*/
/**
 * @namespace
 */
__gh__webApp.data.sortBy = {
	/**
	 * Sort a dataset by date
	 *
	 * @param {array} data - array of data objects with an isodate field
	 */
   	"date": function(data){
		data.sort(function(a, b){
			var dateA=new Date(a.isodate), dateB=new Date(b.isodate);
			return dateB-dateA;
		});
	},

	/**
	 * Sort a dataset by priority
	 *
	 * @param {array} data - array of data objects with an priority field
	 */
    "priority": function(data){
		data.sort(function(a, b){
			return a.priority-b.priority;
		});
	}
};